<template>
    <div>
        
        <!-- Encabezado de la aplicación -->
        <div class="appHeader no-border">
            <div class="left">
                <a href="#" class="headerButton goBack">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">
                Crea tu cuenta
            </div>
            <div class="right">
                <router-link :to="{ name: 'login' }" class="headerButton">
                    Iniciar sesión
                </router-link>
            </div>
        </div>
        <!-- * Encabezado de la aplicación -->

        <!-- Cápsula de la aplicación -->
        <div id="appCapsule">

            <div class="section">
                <div class="splash-page mt-5 mb-5">
                    <div class="iconbox mb-3">
                        <ion-icon name="finger-print-outline"></ion-icon>
                    </div>
                    <h2 class="mb-2">¡Se requiere una invitacion!</h2>
                    <p>Actualmente estamos solo aceptando registros de un grupo limitado de usuarios, si ya tienes tu codigo pulsa en el boton <code>'tengo un codigo'</code> si deseas esperar uno pulsa en <code>"pre-cuenta"</code>.
                    </p>
                </div>
            </div>

            <div class="fixed-bar">
                <div class="row">
                    <div class="col-6">
                        <a href="/active-register" class="btn btn-lg btn-primary btn-block">Ya tengo un codigo</a>
                    </div>
                    <div class="col-6">
                        <a href="/pre-register" class="btn btn-lg btn-secondary btn-block">Pre-registro</a>
                    </div>
                    <div class="col-12 mt-1 mb-1">
                        <a href="/" class="btn btn-lg btn-outline-secondary btn-block">Cancelar</a>
                    </div>
                </div>
            </div>

        </div>
        <!-- * Cápsula de la aplicación -->

        

    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    data() {
        return {
            sending: false,
            username: null,
            email: null,
            password: null,
            passwordC: null,
            errors: [],
        };
    },
    mounted() {
        this.$root.loadBackButtom();
        this.$root.loadInputs();
    },
    methods: {
        ...mapActions(['registerAPI']),
        async checkForm() {
            this.sending = true;
            if (this.username && this.email && this.password && this.passwordC) {
                const isUser = await this.registerAPI({username: this.username, email:this.email, password:this.password});   
                console.log('Registrando', isUser)
                if (isUser == true) this.$router.push({name:'login'})
                if (isUser == true) location.replace('/login')
            }
            this.sending = false;
        }
    }
}
</script>